function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 4,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
// Call the function
initializeReviewsSwiper();

function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-next',
      prevEl: '.m-mcs-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}

function initUISSlider() {
  var swiper = new Swiper(".UISSlider", {
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 1.7,
    spaceBetween: 10,

    breakpoints: {
      0: {
        slidesPerView: 1.7,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
    },
  });
}

document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-collapsible-toggle');
  if (!button) return;
  const item = button.closest('.u-collapsible-item');
  const content = item.querySelector('.u-collapsible-content');
  const isAlreadyActive = item.classList.contains('active');
  const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
  allActiveItems.forEach(activeItem => {
    activeItem.classList.remove('active');
    const activeContent = activeItem.querySelector('.u-collapsible-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});